import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MatriculaHistoricoPayloadModel } from '@shared/models/backend'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class ResidenteHistoricoSituacoesService {
  constructor(private http: HttpClient) {}

  getHistoricoSituacoesMatricula(
    matriculaId: number,
    pageNumber: number,
    pageSize: number
  ): Observable<MatriculaHistoricoPayloadModel> {
    return this.http
      .get<MatriculaHistoricoPayloadModel>(
        `/api/residentes/${matriculaId}/situacoes?size=${pageSize}&page=${pageNumber}`
      )
      .pipe(take(1))
  }
}
